import { useQuery } from "@tanstack/react-query";
import periodidService from "../../services/periodic/PeriodicService";
import { CACHE_TIMES } from "../../utils/queryConstants";

export const useGetPeriodics = (companyId: number) => {
    return useQuery({
        queryKey: ['periodics', companyId],
        queryFn: () => periodidService.GetPeriodics(companyId),
        enabled: !!companyId && companyId !== 0,
        staleTime: CACHE_TIMES.DEFAULT_STALE,
        gcTime: CACHE_TIMES.DEFAULT_GC,
        refetchOnWindowFocus: false,
        placeholderData: (previousData) => previousData,
        select: (periodics) => {
            return periodics
                .map((periodic) => ({
                    id: `${periodic.id}`,
                    building: periodic.building.name,
                    propertyGroupId: periodic.building.propertyGroupId,
                    floor: periodic.floor.name,
                    room: periodic.local,
                    cleaningDate: {
                        scheduleDate: periodic.schedule.scheduleDate,
                        status: periodic.schedule.status,
                        id: Number(periodic.schedule.id),
                        userName: periodic.schedule.username,
                        executionDate: periodic.schedule.executionDate,
                    },
                    profile: periodic.profile.name,
                    task: periodic.task,
                }))
                .sort(
                    (a, b) =>
                        new Date(b.cleaningDate.scheduleDate).getTime() -
                        new Date(a.cleaningDate.scheduleDate).getTime()
                );
        }
    });
};